import { useRecordContext } from 'react-admin';

/**
 * Returns `true` when the component renders inside `<Edit>` — i.e. a record
 * with an id is present in context. Returns `false` inside `<Create>` (no
 * record) or outside any Record context.
 *
 * Use this inside shared form components to gate Create-vs-Edit distinctions
 * without duplicating the boolean cast:
 *
 *   const isEdit = useIsEditMode();
 *   <TextInput autoFocus={!isEdit} helperText={isEdit ? 'keep existing' : undefined} />
 */
export const useIsEditMode = (): boolean => {
  const record = useRecordContext<{ id?: unknown }>();
  return record?.id != null && record.id !== '';
};

export default useIsEditMode;
